import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import useTickets from "./apis/useTickets";
import PopupWrapper from "../../../components/PopupWrapper";
import CreateTicket from "../../../components/CreateTicket/createTicket";
import ErrorBoundary from "../../../components/ErrorBoundary";
import TicketTable from "../../Ticket/TicketTable";
import { useSelector } from "react-redux";

const TicketCard = () => {
  const [showCreateTicket, setShowCreateTicket] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [viewAll, setViewAll] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const tickets = useTickets(refreshTable);

  return (
    <Card className="p-5 border border-primary createTicket h-100">
      <Row className="align-items-center justify-content-between">
        <Col xs="auto">
          <Button
            className=" py-2 btn btn-primary text-white"
            onClick={() => setShowCreateTicket((prev) => !prev)}
          >
            Create Ticket
          </Button>
        </Col>
        <Col xs="auto">
          <Button
            variant="link"
            className="p-0 text-primary link"
            style={{ textDecoration: "none" }}
            onClick={() => setViewAll((prev) => !prev)}
          >
            {" "}
            View All
          </Button>
        </Col>
      </Row>

      <div className="mt-5">
        <h5 className="mb-1">
          {tickets?.[1]} <span className="fw-bold">Closed</span>
        </h5>
        <h5 className="mb-0">
          <span className="text-primary fw-bold">{tickets?.[0]}</span>{" "}
          <span className="text-muted">Pending</span>
        </h5>
      </div>
      {showCreateTicket && (
        <PopupWrapper
          title={
            <h2 className="p-4 font-weight-bold text-dark">Create Ticket</h2>
          }
          extraClass={`${isLargeDevice ? "width-800" : ""}`}
          Component={
            <CreateTicket
              close={() => setShowCreateTicket(false)}
              refreshTable={() => setRefreshTable(!refreshTable)}
            />
          }
          toShow={showCreateTicket}
          closeEventHandler={() => {
            setShowCreateTicket(false);
          }}
        />
      )}
      {viewAll && (
        <TicketsTableModal
          show={viewAll}
          setShow={setViewAll}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          refreshTable={refreshTable}
        />
      )}
    </Card>
  );
};

export default TicketCard;

const TicketsTableModal = ({
  show,
  setShow,
  activeTab,
  setActiveTab,
  refreshTable,
  setTabsData,
}) => {
  return (
    <div>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            <TicketTable
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              refreshTable={refreshTable}
              setTabsData={setTabsData}
            />
          </ErrorBoundary>
        }
        title="Tickets"
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
        }}
      />
    </div>
  );
};
